import { FormCol, FormRow, TextControl } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface SpecifyRowProps { }

const SpecifyRow: FC<SpecifyRowProps> = () => {
  const { t } = useTranslation('NewMessagePage');
  const maxLengthText = 100;
  return (
    <FormRow>
      <FormCol label={t('specify')} labelMarginBottom={36}>
        <TextControl
          maxLength={maxLengthText}
          required
          name="specify"
        />
      </FormCol>
    </FormRow>
  );
};
export default SpecifyRow;
